module.exports = __webpack_public_path__ + "img/2-5.8a345912.png";